import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Fetch categories with pagination
export const fetchCategories = createAsyncThunk(
  'categories/fetchCategories',
  async ({ page = 1, limit = 5,type_name }, thunkAPI) => {
    try {
      const res = await axios.get('/api/v1/categories-type/get', {
        params: { page, limit,type_name },
      });
      return res.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data || err.message);
    }
  }
);

// Add new category type
export const addCategory = createAsyncThunk(
  'categories/addCategory',
  async (categoryData, thunkAPI) => {
    try {
      const res = await axios.post('/api/v1/categories-type/create', categoryData);
      return res.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data || err.message);
    }
  }
);

// Update category type
export const updateCategory = createAsyncThunk(
  'categories/updateCategory',
  async ({ id, updatedData }, thunkAPI) => {
    try {
      const res = await axios.put(`/api/v1/categories-type/update/${id}`, updatedData);
      return res.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data || err.message);
    }
  }
);

// Delete category type
export const deleteCategory = createAsyncThunk(
  'categories/deleteCategory',
  async (id, thunkAPI) => {
    try {
      const res = await axios.delete(`/api/v1/categories-type/delete/${id}`);
      console.log(res.data);
      return { id };
    } catch (err) {
        
      return thunkAPI.rejectWithValue(err.response?.data || err.message);
      
    }
  }
);

const categoriesSlice = createSlice({
  name: 'categories',
  initialState: {
    categories: [],
    total: 0,
    page: 1,
    limit: 5,
    loading: false,
    error: null,
  },
  reducers: {
    setPage: (state, action) => {
      state.page = action.payload;
    },
  },
  extraReducers: (builder) => {
  builder
    // FETCH
    .addCase(fetchCategories.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(fetchCategories.fulfilled, (state, action) => {
      state.loading = false;
      state.categories = action.payload.data;
      state.total = action.payload.total;
    })
    .addCase(fetchCategories.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    })

    // ADD
    .addCase(addCategory.fulfilled, (state, action) => {
      state.categories.unshift(action.payload.data);
      state.total += 1;
      state.error = null;
    })
    .addCase(addCategory.rejected, (state, action) => {
      state.error = action.payload;
    })

    // UPDATE
    .addCase(updateCategory.fulfilled, (state, action) => {
      const updated = action.payload.data;
      console.log('Updated category:', updated);
    //   const index = state.categories.findIndex(cat => cat.id === updated.id);
    //   if (index !== -1) {
    //     state.categories[index] = updated;
    //   }
      state.error = null;
    })
    .addCase(updateCategory.rejected, (state, action) => {
      state.error = action.payload;
    })

    // DELETE
    .addCase(deleteCategory.fulfilled, (state, action) => {
      state.categories = state.categories.filter(cat => cat.id !== action.payload.id);
      state.total -= 1;
      state.error = null;
    })
    .addCase(deleteCategory.rejected, (state, action) => {
      state.error = action.payload;
    });
}

});

export const { setPage } = categoriesSlice.actions;
export default categoriesSlice.reducer;
